import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { PageContext } from "../../config";

import "./style.css";

const InvoiceHeaderView = () => {
  const { t } = useTranslation();
  const { paymentLinkData } = React.useContext(PageContext);

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      className="invoice-header-view w-full"
    >
      <Typography className="typography-body-1">
        {t("common.computedAdIdLabel", { id: paymentLinkData.memberId ?? "" })}
      </Typography>
    </Grid>
  );
};

export default InvoiceHeaderView;
